<template>
  <div>
    <div class="content" style="width: auto">
      <div class="cont-list">
        <span class="list">{{ this.parentRoute.menuName }}-{{ title }}{{ route.menuName }}</span>
        <span style="color: red"> {{ form.supplierApproveStateInfo }}</span>
      </div>

      <el-form label-position="top" label-width="80px" ref="form" :model="form" :rules="rules">
        <div class="edit-card">
          <div style="width: 88%; display: flex">
            <div class="start-label" />
            <span class="text">计划基础信息</span>
          </div>
          <el-row>
            <el-col :span="6" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="no" label="计划单号" v-if="getIsView()">
                <el-input disabled v-model="form.no"></el-input>
              </el-form-item>
              <span class="viewText" v-else>计划单号:{{ form.no }} </span>
            </el-col>
            <el-col :span="6" :class="!getIsView()?'viewCol':''">
              <el-form-item label="创建时间" prop="createdTime" v-if="getIsView()">
                <el-date-picker v-model="form.createdTime" disabled type="datetime" placeholder="系统自动带出创建时间"
                  style="width: 100%">
                </el-date-picker>
              </el-form-item>
              <span class="viewText" v-else>创建时间:{{   parseTime(new Date(form.createdTime), "{y}-{m}-{d} {h}:{i}:{s}") }} </span>
            </el-col>
            <el-col :span="6" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="createdUserName" label="发起人" v-if="getIsView()">
                <el-input disabled v-model="form.createdUserName"></el-input>
              </el-form-item>
              <span class="viewText" v-else>发起人:{{ form.createdUserName }} </span>
            </el-col>
            <el-col :span="6" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="ownerDeptName" label="所属科室" v-if="getIsView()">
                <el-input disabled v-model="form.ownerDeptName"></el-input>
              </el-form-item>
              <span class="viewText" v-else>所属科室:{{ form.ownerDeptName }} </span>
            </el-col>
          
     
            <el-col :span="6" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="deptName" label="需求科室" v-if="getIsView()">
                <el-select v-if="system_setting.IsUseWard" v-model="form.deptName" placeholder="请选择需求科室"
                  :disabled="!editMode" style="width: 100%" filterable :filter-method="getDeptAndWards"
                  @change="applyDeptChange1">
                  <el-option v-for="item in STATIC_DeptAndWards" :key="item.idGroup"
                    :label="item.deptNo+' '+item.deptName + ' ' + (item.wardName ? item.wardName : '')" :value="item.idGroup"></el-option>
                </el-select>
                <el-select v-else v-model="form.deptName" placeholder="请选择需求科室" :disabled="!editMode" style="width: 100%"
                  filterable :filter-method="getDeptsBySessionDeptId" @change="deptChange">
                  <el-option v-for="item in STATIC_Depts" :key="item.id" :label="item.no+' '+item.name"
                    :value="item.id"></el-option>
                </el-select>
                </el-form-item>
                <span class="viewText" v-else>需求科室:{{ form.deptName }} </span>
                </el-col>
              <el-col :span="6" :class="!getIsView()?'viewCol':''">
                <el-form-item prop="warehouseName" label="需求库房" v-if="getIsView()">
                <el-select v-model="form.warehouseName" :disabled="!editMode" placeholder="请选择需求库房" filterable
                  :filter-method="getWarehousesBySessionWarehouseId" @change="warehouseChange" style="width: 100%">
                  <el-option v-for="item in STATIC_Warehouses" :key="item.id" :label="item.name"
                    :value="item.id"></el-option>
                </el-select>
              </el-form-item>
              <span class="viewText" v-else>需求库房:{{ form.warehouseName }} </span>

            </el-col>
            <el-col :span="6" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="supplierName" label="供应商" v-if="getIsView()">
                <el-select v-model="form.supplierName" :disabled="!editMode" placeholder="请选择" filterable
                  :filter-method="(value) => getSuppliers1(value, 1)" @change="supplierChange" style="width: 100%">
                  <el-option v-for="item in STATIC_Suppliers" :key="item.id" :label="item.name"
                    :value="item.id"></el-option>
                </el-select>
              </el-form-item>
              <span class="viewText" v-else>供应商:{{ form.supplierName }} </span>
            </el-col>

            <el-col :span="6" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="oneLevelWarehouseId" label="收货库房" v-if="getIsView()">
                <el-select v-model="form.oneLevelWarehouseName" :disabled="!editMode && !editOrAccpetDisabled"
                  placeholder="请选择收货库房" style="width: 100%" filterable :filter-method="getOneLevelWarehouses"
                  @change="oneLevelWarehouseChange">
                  <el-option v-for="item in STATIC_OneLevelWarehouses" :key="item.id" :label="item.name"
                    :value="item.id"></el-option>
                </el-select>
              </el-form-item>
              <span class="viewText" v-else>收货库房:{{ form.oneLevelWarehouseName }} </span>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="6" :class="!getIsView()?'viewCol':''"> 
              <el-form-item prop="latestTime" label="最迟确认日期" v-if="getIsView()">
                <el-date-picker :disabled="!editOrAccpetDisabled" v-model="form.latestTime" size="small" type="date"
                  format="yyyy-MM-dd" value-format="yyyy-MM-dd" placeholder="确认日期" style="width: 100%"></el-date-picker>
              </el-form-item>
              <span class="viewText" v-else>最迟确认日期:{{ form.latestTime }} </span>
            </el-col>
            <el-col :span="6" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="deliveryTime" label="要求送达日期" v-if="getIsView()">
                <el-date-picker :disabled="!editOrAccpetDisabled" v-model="form.deliveryTime" size="small" type="date"
                  format="yyyy-MM-dd" value-format="yyyy-MM-dd" placeholder="送达日期" style="width: 100%"></el-date-picker>
              </el-form-item>
              <span class="viewText" v-else>要求送达日期:{{ parseTime(new Date(form.deliveryTime) ,"{y}-{m}-{d}") }} </span>
            </el-col>
            <el-col :span="6" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="stateName" label="订单状态" v-if="getIsView()">
                <el-input disabled v-model="form.stateName"></el-input>
              </el-form-item>
              <span class="viewText" v-else>订单状态:{{ form.stateName }} </span>
            </el-col>
            <el-col :span="6" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="totalNumber" label="计划总数量" v-if="getIsView()">
                <el-input disabled placeholder="请输入总数量" v-model="form.totalNumber" type="number"></el-input>
              </el-form-item>
              <span class="viewText" v-else>计划总数量:{{ form.totalNumber }} </span>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="4" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="pressingState" label="紧急标识" v-if="getIsView()">
                <el-select v-model="form.pressingState" :disabled="!editMode" placeholder="请选择" style="width: 100%">
                  <el-option v-for="item in OrderPressingOptions" :key="item.id" :label="item.name" :value="item.id"></el-option>
                </el-select>
              </el-form-item>
              <span class="viewText" v-else>紧急标识:{{ OrderPressingOptions.find(item => item.id === form.pressingState)?.name }} </span>
            </el-col>
            <el-col :span="6" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="totalAmount" label="计划总金额" v-if="getIsView()">
                <el-input type="number" disabled placeholder="请输入总金额" v-model="form.totalAmount"></el-input>
              </el-form-item>
              <span class="viewText" v-else>计划总金额:{{ form.totalAmount }} </span>
            </el-col>
            <el-col :span="10" :class="!getIsView()?'viewCol':''">
              <el-form-item label="备注" prop="remark" v-if="getIsView()">
                <el-input :disabled="!editMode" placeholder="备注" v-model="form.remark"></el-input>
              </el-form-item>
              <span class="viewText" v-else>备注:{{ form.remark }} </span>
            </el-col>
            <el-col :span="4" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="isTempPurchase" label="临采标识" v-if="getIsView()">
                <el-select v-model="form.isTempPurchase" :disabled="!editMode" style="width: 100%">
                  <el-option v-for="item in WhetherOptions" :key="item.id" :label="item.name"
                    :value="item.id"></el-option>
                </el-select>
              </el-form-item>
              <span class="viewText" v-else>临采标识:{{ form.isTempPurchase }} </span>
            </el-col>
          </el-row>
          <el-row style="margin-top: 20px"></el-row>
        </div>

        <div class="edit-card" style="margin-top: 10px; padding-bottom: 10px">
          <div style="width: 88%; display: flex">
            <div class="start-label" />
            <span class="text">备货计划明细</span>
          </div>

          <div v-if="editMode" style="margin: 20px 0 12px 10px">
            <el-button class="btn default" size="small" v-preventReClick @click="handleAddChildForm">新增明细</el-button>
            <el-button :class="childMultiple?'btn' :'btn default'"  size="small" :disabled="childMultiple" v-preventReClick type="danger"
              @click="handleDeleteChildForm">删除</el-button>
              <el-button :class="childMultiple?'btn' :'btn default'"  size="small" :disabled="childMultiple" v-preventReClick
              @click="correctProcureNum">修正采购量(按件装量)</el-button>
          </div>
          <div v-else style="margin: 20px 0 12px 10px">
            <el-button :class="childMultiple?'btn' :'btn default'"  size="small" :disabled="childMultiple" v-preventReClick
            @click="correctProcureNum">修正采购量(按件装量)</el-button>
          </div>

          <el-table ref="childTable" border :data="form.details" style="width: auto; margin: 0 10px"
            @cell-dblclick="cellDblclick" @selection-change="handleChildSelectionChange" :row-class-name="tableRowClassName" stripe
            :header-cell-style="{ background: '#DDEBFF' }">
            <el-table-column type="index" width="50" fixed> </el-table-column>
            <el-table-column type="selection" width="55" align="center" fixed></el-table-column>
            <el-table-column prop="productName" label="产品" fixed width="180">
              <template slot-scope="scope">
                <SelectTable :disabled="!editMode" :columns="supplierProductColumns" :placeholder="'请选择产品'"
                  :innerName="scope.row.productName" :dataList="STATIC_SupplierProducts" @filterMethod="getProductList"
                  @change="(val) => productChange(scope.row, val)" />
              </template>
            </el-table-column>
            <el-table-column show-overflow-tooltip prop="specName" fixed label="产品规格" width="130"></el-table-column>

            <el-table-column prop="supplierProductNo" label="供应商产品编码" width="180"></el-table-column>
            <el-table-column show-overflow-tooltip prop="manufacturerName" label="生产厂家" width="130"></el-table-column>
            <el-table-column prop="number" label="计划数量" width="130">
              <template slot-scope="scope">
                <el-input :disabled="!editOrAccpetDisabled" placeholder="请输入数量" type="number"
                  :id="'number' + scope.$index" min="0" @input="inputChange(scope.row)"
                  v-model="scope.row.number"></el-input>
              </template>
            </el-table-column>
            <el-table-column prop="recommendation" label="建议采购量(按件装量)" min-width="170">
              <template slot-scope="scope">
                {{ scope.row.recommendation?scope.row.recommendation:'' }}
              </template> 
            </el-table-column>
            <el-table-column prop="pressingStateName" width="80" label="紧急标识"></el-table-column>
            <el-table-column prop="orderNumber" label="接单数量" width="100"></el-table-column>
            <el-table-column prop="minUnit" label="最小单位" width="120"></el-table-column>
            <el-table-column prop="packNumber" label="件装量" width="80">
              <template slot-scope="scope">
                {{ scope.row.packNumber?(scope.row.packNumber+scope.row.minUnit+'/'+scope.row.unit):'' }}
              </template>
            </el-table-column>
            <el-table-column prop="unit" label="包装规格" width="120"></el-table-column>
            <el-table-column prop="price" label="单价" width="120"></el-table-column>
            <el-table-column prop="amount" label="小计" width="120"></el-table-column>
            <el-table-column prop="stockNumber" label="库存数量" width="120"></el-table-column>
            <el-table-column show-overflow-tooltip prop="supplierName" label="供应商" width="130"></el-table-column>
            <el-table-column show-overflow-tooltip prop="productRegistCertName" label="产品注册证"
              width="130"></el-table-column>
            <el-table-column prop="undeliveredNumber" label="未配送数量" width="100"></el-table-column>
            <el-table-column prop="unCheckedNumber" label="未验收数量" width="100" />
            <!-- <el-table-column prop="brand" label="品牌" width="160"></el-table-column> -->

            <el-table-column prop="expectedDate" label="预计送达日期" width="150">
              <template slot-scope="scope">
                {{ parseTime(new Date(scope.row.expectedDate), "{y}-{m}-{d}") }}
              </template>
            </el-table-column>

            <el-table-column show-overflow-tooltip prop="productRegistCertNo" label="注册证号"
              width="130"></el-table-column>
              <el-table-column prop="productCode" label="商品代码" width="100"></el-table-column>
              <el-table-column prop="newProductId"  label="平台产品id" width="100"></el-table-column>
            <el-table-column prop="minPrice" v-if="this.system_setting.isUsePriceMonitor" label="平台最低价"
              width="100"></el-table-column>
            <el-table-column show-overflow-tooltip prop="onlineNo" label="挂网号" width="70"></el-table-column>
            <el-table-column prop="medicalInsuranceCategoryNo" show-overflow-tooltip label="医保代码"
              width="200"></el-table-column>
            <el-table-column prop="remark" label="备注" width="200">
              <template slot-scope="scope">
                <el-input :disabled="!editMode" placeholder="请输入备注" v-model="scope.row.remark"></el-input>
              </template>
            </el-table-column>
            <el-table-column fixed="right" width="160" label="完成情况">
              <template slot-scope="scope">
                <el-progress :text-inside="true" :stroke-width="20" :percentage="getPercentage(
                  scope.row.orderNumber - scope.row.unCheckedNumber,
                  scope.row.orderNumber
                )
                  " color="#42b983" />
              </template>
            </el-table-column>
          </el-table>
        </div>

        <ApproveInfo ref="approveInfo" v-if="showWorkFlowInfo" @change="approveInfoChange"></ApproveInfo>
      </el-form>
    </div>
    <div slot="footer" class="footer-bottom">
      <template v-if="form.state == 2">
        <el-button class="btn primary" type="primary" v-preventReClick @click="confirmOrder">同意部分接单</el-button>
        <el-button class="btn default" v-preventReClick @click="cancelOrder">拒绝部分接单</el-button>
      </template>
      <template v-else>
        <el-button v-if="editMode" class="btn default" v-preventReClick @click="cancel">取 消</el-button>
        <my-button v-if="editMode && form.status != 0" class="btn primary" type="primary" v-preventReClick
          @click="proTemSave">暂 存</my-button>
        <my-button v-if="editMode" class="btn primary" type="primary" v-preventReClick @click="submit">确 定</my-button>
        <my-button v-if="showWorkFlowInfo" v-loading="loading" class="btn primary" type="primary" v-preventReClick @click="approve">确 定</my-button>
        <el-button v-if="!editMode" class="btn default" v-preventReClick @click="cancel">返 回</el-button>
      </template>
    </div>

    <el-dialog title="集采超量提示" :visible.sync="dialogVisible" width="700px" :before-close="handleClose">
      <span>存在集采超量产品，超量明细如下，是否继续？</span>

      <el-table border :data="dialogData" :max-height="400" style="width: auto; margin: 0 10px" stripe
        :header-cell-style="{ background: '#DDEBFF' }">
        <el-table-column prop="supplierProductNo" label="产品编码" width="180"></el-table-column>
        <el-table-column prop="productName" label="产品名称" width="180"></el-table-column>
        <el-table-column prop="specName" label="规格型号" width="180"></el-table-column>
        <el-table-column prop="number" label="超量数量" width="180"></el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="excessEvt">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="提示" :visible.sync="correctBox" width="400" :before-close="handleClose">
      <h4>您确定对下列产品的采购数量按建议采购量做如下修正吗？</h4>
      <el-table border :data="childMultipleSelection" :max-height="400" style="width: auto; margin: 0 10px" stripe
        :header-cell-style="{ background: '#DDEBFF' }">
        <el-table-column prop="productName" label="产品名称" min-width="110"></el-table-column>
        <el-table-column prop="specName" label="规格型号" min-width="110"></el-table-column>
        <el-table-column prop="number" label="原采购量" min-width="110"></el-table-column>
        <el-table-column prop="recommendation" label="建议采购量(按件装量)" min-width="120"></el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button @click="correctBox = false">取 消</el-button>
        <el-button type="primary" @click="correctEvt">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import GetDataMixin from "@/mixin/getData-mixin.js";
import GetDataSpdMixin from "@/mixin/getData-spd-mixin.js";
import {
  GetStockNumber,
  GetStockUpPlanById,
  SaveStockUpPlan,
  RejectStockUpPlan,
  ConfirmStockUpPlan,
  CancelStockUpPlan,
  ValidateSupplierProducts,
  StockUpPlanChaoLiangValidate
} from "@/api";
import SelectTable from "@/components/select-table";
import ApproveInfo from "@/components/approve-info";
import {
  WhetherOptions,
  OrderPressingOptions
} from "@/enum";
export default {
  name: "manufacturerEdit",
  mixins: [GetDataMixin, GetDataSpdMixin],
  components: {
    SelectTable,
    ApproveInfo,
  },
  data () {
    return {
      GetDataAction: GetStockUpPlanById,
      SaveDataAction: SaveStockUpPlan,
      reject: RejectStockUpPlan,
      WhetherOptions:WhetherOptions,
      OrderPressingOptions:OrderPressingOptions,
      form: {},
      rules: {
        latestTime: [
          {
            required: true,
            message: "请选择最迟确认日期",
            trigger: "blur",
          },
        ],
        deliveryTime: [
          {
            required: true,
            message: "请选择最迟确认日期",
            trigger: "blur",
          },
        ],
        supplierName: [
          {
            required: true,
            message: "请选择供应商",
            trigger: "blur",
          },
        ],
        warehouseName: [
          {
            required: true,
            message: "请选择需求库房",
            trigger: "blur",
          },
        ],
        
        deptName: [
          {
            required: true,
            message: "请选择需求科室",
            trigger: "blur",
          },
        ],
        oneLevelWarehouseId: [
          {
            required: true,
            message: "请选择收货库房",
            trigger: "blur",
          },
        ],
        isTempPurchase: [
          {
            required: true,
            message: "请选择临采标识",
            trigger: "blur",
          },
        ],
        pressingState:[{
          required: true,
          message: "请选择紧急标识",
          trigger: "blur",
        }]
      },
      childFormRules: {
        price: [
          {
            required: true,
            message: "请输入采购价",
            trigger: "blur",
          },
        ],
        number: [
          {
            required: true,
            message: "数量不能为空",
            trigger: "blur",
          },
          {
            type: "number",
            min: 0.01,
            message: "数量必须大于0",
            trigger: "blur",
          },
          
        ],
    
      },
      editMode: false,
      showWorkFlowInfo: false,
      assetList: [],
      // 子表
      childIds: [],
      childMultipleSelection: [],
      childMultiple: true,
      childForm: {},
      dateDisabled: false,
      editOrAccpetDisabled: false,
      dialogVisible: false,
      dialogData: [],
      correctBox: false
    };
  },

  created () {
    var query = this.$route.query;
    if (query.id) {
      this.handleUpdate(query.id);
    } else {
      this.handleAdd();
    }

    if (this.system_setting.IsUseWard) {
      this.getDeptAndWards()

    } else {
      this.getDeptsBySessionDeptId("");
    }
    // if (query.editMode == 1) {
    //   this.editMode = true
    // }

    this.getProductList("");
    this.getSuppliers1("", 1);
    this.getWarehousesBySessionWarehouseId("");
    this.getOneLevelWarehouses("");
  },
  methods: {
    // 新建
    handleAdd () {
      this.resetForm();
      this.form.deptName = this.form.deptName??''
      this.editMode = true;
      this.editOrAccpetDisabled = true;
    },
    // 编辑
    handleUpdate (id) {
      this.GetDataAction({
        id,
      }).then((res) => {
        // this.resetForm()
        this.form = res.returnData;
        this.getLocations(this.form.warehouseId);
        this.form.details.forEach((e, index) => {
          e.$index = index + 1;
        });

        this.initWorkFlowProperty(this.form);

        this.dateDisabled = true;
        // console.log(this.formMode, 'mode')
        if (this.formMode == 1) {
          this.dateDisabled = false;
        }
        this.editOrAccpetDisabled = true;
        if (this.formMode == 0) {
          this.editOrAccpetDisabled = false; //查看详情
        }
        if (
          this.form.status == 1 &&
          this.form.approverIds &&
          this.form.approverIds.split(";").indexOf(this.userInfo.id + "") != -1
        ) {
          this.dateDisabled = false;
          this.editOrAccpetDisabled = true;
        }
      });
    },
    // 保存
    submit () {
      this.$store.dispatch('SetLoading',true)
      this.$refs["form"].validate((valid) => {
        if (!valid) {
          this.$store.dispatch('SetLoading',false)
          return false;
        }

        let supplierProductIds = this.form.details.map((e) => e.supplierProductId);
        if (!supplierProductIds || supplierProductIds.length == 0) {
          this.$my_message("存在没有供应商产品的明细表", "warning");
          this.$store.dispatch('SetLoading',false)
          return;
        }

        const h = this.$createElement;
        let show = false
        let content = [h("p", "")];
        this.form.details.forEach((item, index) => {
          if (item.number < item.recommendation) {
            show = true
            content.push(h("p", `第${index + 1}行：产品名称 [${item.productName
              }] 采购数量不满足件装量要求`))

          }
        })
        if (show) {
          content.push(h("p","如要修改请点击【取消】，如果不修改，请点击【确定】"))
          this.$confirm("提示", {
            title: "提示",
            type: "warning",
            showClose: false,
            message: h("div", content),
          }).then(() => {
            StockUpPlanChaoLiangValidate(this.form).then(res => {
              if (res.length !== 0) {
                this.dialogVisible = true
                this.dialogData = res

              } else {
                this.save()

              }
            })
          })
          this.$store.dispatch('SetLoading',false)
          return
        }

        StockUpPlanChaoLiangValidate(this.form).then(res => {
          if (res.length !== 0) {
            this.dialogVisible = true
            this.dialogData = res

          } else {
            this.save()

          }
        })



      });
    },
    save () {
      let supplierProductIds = this.form.details.map((e) => e.supplierProductId);
      ValidateSupplierProducts({
        ids: supplierProductIds,
      })
        .then((res) => {
          if (res.returnData && res.returnData.length > 0) {
            const h = this.$createElement;
            let content = [];
            for (let i = 0; i < this.form.details.length; i++) {
              res.returnData.forEach((item) => {
                if (this.form.details[i].supplierProductId == item.key) {
                  content.push(
                    h(
                      "p",
                      `第${i + 1}行：产品名称[${this.form.details[i].productName
                      }]，规格型号[${this.form.details[i].specName}]${item.errorMessage
                      }\n`
                    )
                  );
                }
              });
            }
            content.push(h("p", `不审核仍可下单。`));

            return this.$confirm("提示", {
              title: "提示",
              type: "warning",
              customClass: "promptBox",
              message: h("div", content),
            });
          }
        })
        .then((res) => {
          return this.SaveDataAction(this.form).finally(() => {
          this.$store.dispatch('SetLoading',false)
        });;
        })
        .then((res) => {
          this.loading = false
          this.$my_message(`执行成功`, "success");
          sessionStorage.setItem("editMode", 0);
          // this.$router.push({ path: this.getMainPath(this.$route.path) });
          this.routePushWithParams(
            this.getMainPath(this.$route.path),
            this.$route.params
          );
        });
    },
    resetForm () {
      this.form = {
        totalNumber: 0,
        totalAmount: 0,
        category: 0,
        remark: "",
        deptName: this.system_setting.IsUseWard?`${this.mySessionStorage.getDeptName()??''} ${this.mySessionStorage.getWardName()??''} `:(this.mySessionStorage.getDeptName()??''),
        deptId: this.mySessionStorage.getDeptId(),
        wardId:this.system_setting.IsUseWard?this.mySessionStorage.getWardId():'',
        warehouseId: "",
        warehouseName: "",
        details: [],
        state: 1, // 待供应商确认
        createdTime: this.parseTime(new Date()),
        updateTime: this.parseTime(new Date()),
        createdUserName: this.userInfo.name,
        ownerDeptName: this.userInfo.deptName,
        date: this.parseTime(new Date(), "{y}-{m}-{d}"),
        isTempPurchase:0,
        pressingState:0,
        orgCode :sessionStorage.getItem('orgId'),
      };

      this.$forceUpdate();
      this.setDefaultWarehouseBySessionWarehouseId();
      // this.setDefaultDeptBySessionDeptId();
    },
       // 取消编辑
    cancel () { 
      this.$store.dispatch('SetLoading',false)
      // this.$my_confirm("确认要中断当前操作吗？", "提示", {
      //   type: "warning",
      // }).then(() => {
      //   this.$router.go(-1);
      // });
      // this.$router.push({ path: this.getMainPath(this.$route.path) });
      this.routePushWithParams(this.getMainPath(this.$route.path), this.$route.params);
    },

    // 明细表
    handleAddChildForm () {
      if(!this.form.warehouseId){
        this.$message({
          message: '请选择需求库房后再新增',
          type: 'warning'
        });
        return
      }
         if(!this.form.supplierId){
        this.$message({
          message: '请选择供应商后再新增',
          type: 'warning'
        });
        return
      }
      this.openSubformModal = true;
      this.editChildren = false;
      this.resetDetailFormData();
      this.childForm.isVoided= false
      this.form.details.push(this.childForm);
      this.autoTotalAmount();
      this.getProductList("");
    },
    handleDeleteChildForm () {
      this.form.details = this.form.details.filter(
        (i) => !this.childIds.includes(i.$index)
      );
      this.form.details.forEach((e, index) => {
        e.$index = index + 1;
      });

      this.autoTotalAmount();
    },
    handleChildSelectionChange (selection) {
      this.childMultipleSelection = selection;
      this.childIds = selection.map((item) => item.$index);
      this.childMultiple = !selection.length;
    },
    cellDblclick (row, column, cell, event) {
      // // 打开子表弹窗
      // this.openSubformModal = true;
      // this.editChildren = true;
      // this.resetDetailFormData();
      // this.childForm = JSON.parse(JSON.stringify(row));
      // this.childForm.details.forEach((e, index) => {
      //   e.$index = index + 1;
      // });
    },

    resetDetailFormData () {
      this.childForm = {
        $index: this.form.details.length + 1,
        no: "",
        productName: "",
        specName: "",
        manufacturerName: "",
        locationName: "",
        mainNo: "",
        traceNo: "",
        productId: "",
        specId: "",
        productRegistCertNo: "",
        onlineNo: "",
        unit: "",
        minUnit: "",
        packSpec: "",
        manufacturerId: "",
        locationId: "",
        manufactureDate: "",
        batch: "",
        validityDate: "",
        serialNo: "",
        number: 1,
        price: 0,
        amount: 0,
        remark: "",
      };
    },
    cancelChildDialog () {
      this.openSubformModal = false;
    },
    submitChildForm () {
      this.pushChildForm(true);
    },
    continueAdd () {
      this.editChildren = false;
      this.pushChildForm();
      // this.resetDetailFormData();

      this.getProductList("");
    },
    excessEvt () {
      this.dialogVisible = false
      this.save()
    },
    pushChildForm (close) {
      this.$refs["childForm"].validate((valid) => {
        if (!valid) {
          return false;
        }
        this.childForm.orgCode = sessionStorage.getItem('orgId')
        // this.capitalSourceChange()
        let item = this.form.details.find(
          (e) =>
            e.$index != this.childForm.$index &&
            e.supplierProductId == this.childForm.supplierProductId //&&
          // e.price == this.childForm.price &&
          // e.locationName == this.childForm.locationName &&
          // e.assetSource == this.childForm.assetSource &&
          // e.packDesc == this.childForm.packDesc &&
          // e.manufacturerId == this.childForm.manufacturerId &&
          // e.certId == this.childForm.certId &&
          // e.brandId == this.childForm.brandId
        );
        if (item && !this.editChildren) {
          // 新增有重复项提示
          // Object.assign(item, this.childForm);
          this.$my_message(`当前产品信息已存在，请去子表编辑！`, "error");
          return;
        } else if (item && this.editChildren) {
          // 编辑且有重复项
          this.$my_message(`当前产品信息已存在，请去子表编辑！`, "error");
          return;
        } else if (!item && this.editChildren) {
          // 编辑
          item = this.form.details.find((e) => e.$index == this.childForm.$index);
          Object.assign(item, this.childForm);
        } else {
          this.form.details.push(this.childForm);
        }

        this.autoTotalAmount();
        this.resetDetailFormData();
        if (close) {
          this.openSubformModal = false;
        }
      });
    },
    // childNumberChange () {
    //   this.childForm.notReceivedNumber = this.childForm.number
    //   this.childForm.planOrderNumber = this.childForm.number
    //   this.childForm.actualOrderNumber = this.childForm.number
    //   this.autoAmount()
    // },
    // autoAmount () {
    //   this.childForm.amount =
    //     (this.childForm.number * this.childForm.price).toFixed(4) * 1;
    //   this.childForm.unBillAmount = this.childForm.amount;
    // },

    tableRowClassName ({ row, rowIndex }) {
      if (row.isVoided) {
        return 'through'
      }
      if (row.isVoided == undefined) {
        return 'warning-row'
      }
    },
    autoTotalAmount () {
      let totalNumber = 0;
      let totalAmount = 0;
      this.form.details.forEach((element, index) => {
        // 重置表格数据的序号
        element.$index = index + 1;
        totalNumber = totalNumber * 1 + element.number * 1;
        totalAmount = totalAmount * 1 + element.amount * 1;
      });
      this.form.totalNumber = totalNumber.toFixed(3) * 1;
      this.form.totalAmount = totalAmount.toFixed(4) * 1;
      this.form.unBillNumber = totalNumber;
      this.form.unBillAmount = totalAmount;
    },

    // change event
    supplierChange (val) {
      this.form.supplierId = val;
      this.form.details = []
      this.getProductList("");
    },
    applyDeptChange1 (val) {
      let arr = this.STATIC_DeptAndWards.filter(res => res.idGroup == val)
      this.form.deptName = arr[0].deptName + " " + (arr[0].wardName ? arr[0].wardName : '');
      this.form.deptId = arr[0].deptId
      this.form.wardId = arr[0].wardId
    },
    deptChange (val) {
      this.form.deptId = val;
    },
    warehouseChange (val) {
      this.form.warehouseId = val;
    },
    productChange (row, val) {
      // let arr = this.STATIC_SupplierProducts.filter(item => item.id == val.id)
      let id = row.id;
      // let arr = this.STATIC_ApplySupplierProducts.filter((item) => item.id == row.id)
      row = Object.assign(row, val); // this.mapper.SupplierProduct2Form(this.childForm, arr[0])
      row.id = id;
      row.supplierProductId = val.id;
      row.number = 1;
      row.stockNumber = 0;
      row.undeliveredNumber = row.number;
      row.unCheckedNumber = row.number;
      row.orderNumber = row.number;
      row.price = row.purchasePrice;
      row.amount = row.price * row.number;
      row.supplierProductNo = row.no;
      row.recommendation =  row.packNumber?row.packNumber:''
      row.remark = "";

      // 检查是否为临采，并更新数量
      if (this.form.isTempPurchase == 1 ) {
        console.log('临采标识：是')
        console.log('临采数量sporadicNumber：',row.sporadicNumber)
        console.log('已采数量purchasedNumber：',row.purchasedNumber)
        row.number = row.sporadicNumber - row.purchasedNumber;
      } else {
        console.log('临采标识：否')
        row.number = 1;
      }

      GetStockNumber({
        supplierProductId: row.supplierProductId,
        warehouseId: this.form.warehouseId,
      }).then((res) => {
        row.stockNumber = res.returnData.stockNumber;
      });

      this.autoTotalAmount();

      // this.$refs.childForm.validateField('productName')

      setTimeout(() => {
        document.getElementById("number" + (row.$index - 1)).focus();
        document.getElementById("number" + (row.$index - 1)).select();
      }, 1);
    },
    inputChange (row) {
      row.undeliveredNumber = row.number;
      row.unCheckedNumber = row.number;
      row.orderNumber = row.number;
      row.amount = row.price * row.number;
      if(row.packNumber){
        row.recommendation = this.divideAndConditionallyAddOne(row.number, row.packNumber) * row.packNumber

      }
      
      this.autoTotalAmount();
    },
    oneLevelWarehouseChange (val) {
      this.form.oneLevelWarehouseId = val;
      let arr = this.STATIC_OneLevelWarehouses.filter((item) => item.id == val);
      this.form.oneLevelWarehouseManagerId = arr ? arr[0].managerId : "";
    },

    getProductList (keyWord) {
      // query.pageIndex = 1
      // query.pageSize = 100
      // query.isEnabled = 1
      // query.supplierId = this.form.supplierId
      // query.status = 2
      // query.deptId = this.userInfo.deptId
      // query.stockCategory = 1
      this.getSupplierProducts(
        //query)
        {
          keyWord: keyWord,
          pageIndex: 1,
          pageSize: 100,
          isEnabled: 1,
          supplierId: this.form.supplierId,
          status: 2,
          isTempPurchase:this.form.isTempPurchase
        }
      );
    },

    //other
    confirmOrder () {
      this.$confirm("接单数量不等于订购数量，是否继续采购？", "提示", {
        type: "warning",
      })
        .then(() => {
          return ConfirmStockUpPlan({
            id: this.form.id,
          });
        })
        .then((res) => {
          if (res.successful) {
            this.cancel();
            this.$my_message(`提交成功`, "success");
          }
        });
    },
    cancelOrder () {
      CancelStockUpPlan({
            id: this.form.id,
          })
        .then((res) => {
          if (res.successful) {
            this.cancel();
            this.$my_message(`取消成功`, "success");
          }
        });
    },
    handleClose () {
      this.correctBox = false
      this.dialogVisible = false
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/.el-dialog__body {
  overflow: auto !important;
}

/deep/.el-input-number .el-input__inner {
  text-align: left !important;
}
/deep/.through {
  color: #000;
  text-decoration: line-through !important;
}
/deep/.through .el-input__inner {
  text-decoration: line-through !important;
}
</style>

<style>
.promptBox {
  width: 800px !important;
  max-height: 300px;
}
.el-table .warning-row {
  background: oldlace;
}
</style>
